<template>
<div id="wlff">
  <!-- <van-loading class="mar" v-if="loading" type="spinner" size="24px" vertical>加载中...</van-loading> -->

 <div class="cont">
    <van-collapse v-model="activeNames">
        <van-collapse-item title="订单轨迹" name="1">
          <van-steps  direction="vertical" active-color="#ccc" :active-icon="spot">
            <van-step v-for="(item, index) in list" :key="index">
              <div :class="index ===0 ? 'cr1': 'cr2'" class="">{{item.content}}</div>
              <p class="cleft">{{item.gmtCreated}}</p>
            </van-step>
          </van-steps>
        </van-collapse-item>
      </van-collapse>
 </div>

  <!-- <div class="cont">
    <div class="c1" v-for="(item, index) in list" :key="index">
      <div class="cleft" :class="index == 0 ? 'cr1': 'cr2'">{{item.gmtCreated}}</div>
      <div v-show="strHight[index]" class="yuan" :class="index == 0 ? 'br1': 'br2'">
        <div :style="{'height': strHight[index] + 'px'}" v-if="index != list.length -1" class="shuxian"></div>
      </div>
      <div :class="index == 0 ? 'cr1': 'cr2'" class="cright">{{item.content}}</div>
    </div>
    <EmptyItem v-if="list.length ==0" :title="'暂无'+textFomat[code]+'轨迹'" :url="emurl" info></EmptyItem>
  </div> -->



</div>
</template>
<script>
import http from "@/utils/axios";
import EmptyItem from "@/views/shareDiscovery/components/emptyItem";

export default { 
  props:{
    subid:{
      default:"",
      require:true,
      type:[String, Number]
    },
    code:{
      default:"history",
      require:false,
      type:String
    }
  },
  data() {
    return {
      activeNames: ["1"],
      loading:true,
      list: [],
      strHight:[],
      spot:require('@/assets/image/spot.png'),
      emurl: require('@/assets/image/order_empty@2x.png'),
      urlFormat:{
        'express': 'order/admin/logisticsBySubOrderId/',
        'history': 'order/admin/history/suborder/'
      },
      textFomat:{
        'express': '物流',
        'history': '订单'
      }
    };
  },
  methods: {
    init(){
      this.loading = true;
      http({
        url: this.urlFormat[this.code] + this.subid,
        method: "get",
      }).then(rps => {
        if (rps.code === 200) {
          this.list = rps.data;
          setTimeout(()=>{
            if(this.code == 'express'){
              this.renderExpress(rps)
            }else{
              setTimeout(()=>{
                this.reder()
              },1000)
            }
          },800)
        }else{
          this.loading = false;
        }
      });
    },
    reder(){
      let str = document.getElementsByClassName("c1");
      for (let index = 0; index < str.length; index++) {
        const element = str[index];
        this.strHight.push(element.clientHeight + 5);
      }
      this.loading = false;
      // console.log(this.strHight)
    },
    renderExpress(rps){
      let res= rps.data && rps.data.info && typeof rps.data.info === 'string' && JSON.parse(rps.data.info) || rps.data.info;
      this.list = res || [];
      this.list.forEach(element => {
        element.gmtCreated = element.time
        element.content = element.context
      });
      setTimeout(()=>{
        this.reder()
      },1000)
    }
  },
  created() {
    this.init();
  },
  components: {EmptyItem}
};
</script>
<style lang="less" scoped>
.van-step--vertical::after{border: none;}
.van-step{font-size: 24px;}
/deep/.van-step__circle{
  width: 22px;height: 22px;
  background: #DDDDDD;
}
/deep/.van-step__line{
  background-color: #DDDDDD;
}
.mar{
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
.cr1{font-weight: bold;
color: #666666;font-size: 24px;}
.cr2{font-size: 24px;color:#999}
.cleft{
  color: #ccc;
}
#wlff{
  .cont{
    background-color: #ffffff;
    font-size: 22px;
    border-radius:20px;
    .c1{
      display:-webkit-flex;
      // display:flex;
      // -webkit-justify-content:space-between;
      // justify-content:space-between;
      padding-bottom: 50px;
      .cr1{
        color:#F8A651;
      }
      .cr2{
        color:#999999;
      }
      .cleft{
          width: 140px;
          margin-right: 20px;
      }

      /deep/ .yuan{
        width: 22px!important;
        height: 22px !important;
        border-radius: 50% !important;
        position: relative;
        .shuxian{
          position:absolute;
          left: 0;
          top: 0;
          z-index: 1;
          margin-left: 8px;
          margin-top: 23px;
          border-left: 2PX solid #F2F2F2;;
        }
      }
      .br1{
        background:#F8A651;
      }
      .br2{
        // background:#CCCCCC;
          background: #F2F2F2;
      }
      .cright{
        width: 435px;
        margin-left: 20px;
      }
    }
    .shguxian{
      border-left: 1PX solid #CCCCCC;
    }
  }
  .f12{
    font-size: 22px;
  }
}
</style>